import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { siteInfo, heroImage } from '../data/mock';

const HomePage = () => {
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    setIsLoaded(true);
  }, []);

  return (
    <div className="min-h-screen">
      {/* Hero Section - Full Screen */}
      <section className="relative h-screen w-full overflow-hidden">
        {/* Background Image */}
        <div className="absolute inset-0">
          <img
            src={heroImage}
            alt="Anaé Vilnor Photography"
            className={`w-full h-full object-cover transition-all duration-1000 ${
              isLoaded ? 'scale-100 opacity-100' : 'scale-105 opacity-0'
            }`}
            style={{ filter: 'grayscale(100%)' }}
          />
          {/* Overlay */}
          <div className="absolute inset-0 bg-black/40" />
        </div>

        {/* Content */}
        <div className="relative h-full flex flex-col justify-center items-center text-center text-white px-6">
          <div className={`transition-all duration-1000 delay-300 ${
            isLoaded ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
          }`}>
            <h1 className="hero-title text-white mb-4">
              {siteInfo.name}
            </h1>
            <div className="w-16 h-px bg-white/50 mx-auto mb-6" />
            <p className="nav-link text-white/80 mb-4">
              {siteInfo.tagline}
            </p>
            <p className="caption-text text-white/60 mb-12">
              {siteInfo.subtitle}
            </p>
          </div>

          {/* CTA Buttons */}
          <div className={`flex flex-col sm:flex-row gap-4 transition-all duration-1000 delay-500 ${
            isLoaded ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
          }`}>
            <Link
              to="/portfolio"
              className="btn-outline-white group"
            >
              Portfolio
              <ArrowRight size={14} className="ml-2 group-hover:translate-x-1 transition-transform duration-300" />
            </Link>
            <Link
              to="/contact"
              className="btn-outline-white"
            >
              Contact
            </Link>
          </div>
        </div>

        {/* Scroll Indicator */}
        <div className={`absolute bottom-8 left-1/2 -translate-x-1/2 transition-all duration-1000 delay-700 ${
          isLoaded ? 'opacity-100' : 'opacity-0'
        }`}>
          <div className="flex flex-col items-center gap-2">
            <span className="nav-link text-white/50 text-[10px]">Défiler</span>
            <div className="w-px h-12 bg-gradient-to-b from-white/50 to-transparent" />
          </div>
        </div>
      </section>
    </div>
  );
};

export default HomePage;
